import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Auth as AuthAPI } from "@air/api";
import { callOnFullAccountUserPool } from "@air/utils-auth";
import { reportErrorToBugsnag } from "@air/utils-error";
import Link from "next/link";
import { Routes } from "~/constants/routes";
/**
 * @deprecated Use `loginViaEmail` from `@air/utils-auth` instead.
 */ export const loginViaEmail = async (param)=>{
    let { username, password, cognitoUser } = param;
    return callOnFullAccountUserPool(async ()=>{
        try {
            let user = cognitoUser;
            if (!user) {
                user = await AuthAPI.signIn(username, password);
            }
            if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                return {
                    cognitoUser: user,
                    updatePassword: true
                };
            } else {
                const userSession = user.getSignInUserSession();
                if (!userSession) throw new Error("no user session");
                const { payload } = userSession.getIdToken();
                const token = userSession.getIdToken().getJwtToken();
                const userInfo = {
                    sub: payload.sub,
                    email: payload.email
                };
                return {
                    cognitoUser: user,
                    token,
                    userInfo
                };
            }
        } catch (_error) {
            const error = reportErrorToBugsnag({
                error: _error,
                context: "Error logging in with Cognito"
            });
            if (error.message.includes("PasswordResetRequiredException")) {
                return {
                    resetPassword: true
                };
            }
            throw error;
        }
    });
};
const extractIdentityProvider = (rawErrorMessage)=>{
    // workaround to getting structured data back on an error returned from a trigger running behind cognito
    const errorMessageParts = rawErrorMessage.split("::");
    if (errorMessageParts.length <= 1) {
        // assume default IdP if message isn't formatted correctly
        return "default";
    }
    const internalErrorMessagePart = rawErrorMessage.split("::")[1];
    // strip off period appended to message by cognito
    const serializedInternalError = internalErrorMessagePart.substring(0, internalErrorMessagePart.length - 1);
    const { identityProvider } = JSON.parse(serializedInternalError);
    return identityProvider;
};
const existingAccountLink = (identityProvider)=>{
    switch(identityProvider){
        case "google":
            return /*#__PURE__*/ _jsx("button", {
                className: "text-blue-9 underline",
                onClick: ()=>AuthAPI.googleSignIn(),
                children: "Login with Google →"
            });
        case "apple":
            return /*#__PURE__*/ _jsx("button", {
                className: "text-blue-9 underline",
                onClick: ()=>AuthAPI.appleSignIn(),
                children: "Login with Apple →"
            });
        default:
            return /*#__PURE__*/ _jsx(Link, {
                href: Routes.auth.login,
                children: "Log in →"
            });
    }
};
export const ExistingAccountMessageWithAuthLink = (param)=>{
    let { rawErrorMessage, identityProvider, messagePrefix } = param;
    const idp = identityProvider || extractIdentityProvider(rawErrorMessage || "");
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            messagePrefix,
            messagePrefix.endsWith(".") ? "" : ".",
            " ",
            existingAccountLink(idp)
        ]
    });
};
export const PASSWORD_REQS_STRING = "8+ characters, one number, and one capital letter";
